import React from 'react'
import { GoOrganization } from "react-icons/go";
// import { BsGlobe2 } from "react-icons/bs";
// import { FaDollarSign } from "react-icons/fa6";
import { BiSolidLike } from "react-icons/bi";
// import { PieChart1 } from '../graphs/PieChart1';
import { AreaChart1 } from '../graphs/AreaChart1';

export const ClinicDashboard = ({ adminInfo }) => {
    return (
        <div className='w-full card-bg-admin my-10 py-10 rounded-lg'>
            <div className='ml-5'>
                <h1 className='text-7xl font-bold'>12,360</h1>
                <h3 className='text-blue-900 font-semibold italic'>Total Bookings this week</h3>
            </div>
            <div className='flex flex-wrap flex-row w-full mt-4 justify-around'>
                <div className='flex flex-col w-[60%] gap-10'>
                    <div className='flex justify-around items-center w-full  bg-white rounded-xl p-5'>
                        <div className='w-[25%] flex flex-col items-center'>
                            <GoOrganization className='text-4xl text-blue-900' />
                            <p className='text-2xl font-semibold'>{adminInfo?.associatedClinics?.length}</p>
                            <p className='text-blue-500 italic'>Total Clinics</p>
                        </div>
                        <div className='w-[75%]'>
                            <AreaChart1 />
                        </div>
                    </div>
                    {/* <div className='flex justify-around items-center w-full bg-white rounded-xl p-5'>
                        <div className=' flex flex-col items-center w-[25%]'>
                            <BsGlobe2 className='text-4xl text-blue-900' />
                            <p className='text-2xl font-semibold'>1.2Lacs</p>
                            <p className='text-blue-500 italic'>Record Transferred</p>
                        </div>
                        <div className='w-[75%]'>
                            <PieChart1 />
                        </div>
                    </div> */}
                </div>
                <div className='flex lg:flex-col flex-row h-full gap-10 w-fit justify-start'>
                    {/* <div className='flex justify-around items-center w-full bg-white rounded-xl p-5'>
                        <div className='w-fit flex flex-col items-center'>
                            <FaDollarSign className='text-4xl text-blue-900' />
                            <p className='text-2xl font-semibold'>3,60,000</p>
                            <p className='text-blue-400 italic'>weekly Transactions</p>
                        </div>
                    </div> */}
                    <div className='flex justify-around items-center w-full bg-white rounded-xl p-10'>
                        <div className='w-fit flex flex-col items-center'>
                            <BiSolidLike className='text-4xl text-blue-900' />
                            <p className='text-2xl font-semibold'>370</p>
                            <p className='text-blue-500 italic'>Issues Solved</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
